/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { SupportRequestCreateRequestType } from '../../types/SupportRequestCreateRequestType';

export const SupportRequestCreateRequest: core.serialization.Schema<
    serializers.SupportRequestCreateRequest.Raw,
    Truvity.SupportRequestCreateRequest
> = core.serialization.object({
    message: core.serialization.string(),
    type: SupportRequestCreateRequestType,
});

export declare namespace SupportRequestCreateRequest {
    export interface Raw {
        message: string;
        type: SupportRequestCreateRequestType.Raw;
    }
}
